// HomePage.js
import React from 'react';
import logo from '../images/IG.png'
import "../page-styles/home.css"
import "../styles/general.css"
import "../styles/buttons.css"
import Hero from '../components/HeroBg';
import HeroLink from '../components/HeroLink';
import field from '../images/field.png';
import scouting from "../images/scouting.png"

// Spline editor -> Export -> Code -> React, then copy the scene URL.
const HERO_SCENE = 'https://prod.spline.design/1MifSG-HXEi3PsPb/scene.splinecode';

const Home = () => {
  return (
    <div>
      <Hero
        image={logo}
        title={"Capybaras (2055) Programming Website"}
        scene={HERO_SCENE}
      />

      <main>
      <section className="project-info">
          <div className='subheader'>Welcome to 2055's Programming Website!</div>
          <div className='text'>
            This is a website that helps with programming for Vex Robotics Competitions (VRC). Inspired by features on Lemlib to help users understand the precise placements of their robots on the field. 
          </div>
          <div className='text'>
            It also includes an online replica of the Vex Via app, which is a scouting app that allows users to record data about other teams and events. No installations are required!
          </div>
      </section>

      <HeroLink image={field} title={"Robot Position Tracker"} text={"A webpage to help with figuring out the placement of robots"} buttons={[{name: "Robot Position Tracker", link: "/tracker"}, {name: "Path Visualizer", link: "/path-record"}, {name: "Code Generator", link: "/code-generator"}, {name: "Test", link: "/test"}]} />
      <br />
      <HeroLink image={scouting} title={"Scouting"} text={"A webpage to help with scouting"} buttons={[{name: "Scouting", link: "/vexvia/teams"}, {name: "Vex Via", link: "/vexvia"}, {name: "HS Worlds Division Predictor", link: "/predictor"}, {name: "MS Worlds Division Predictor", link: "/predictorMS"}]} />
        
        <section className="contact">
          <div className='subheader'>Contact Us</div>
          <div className='text'>
            Visit us at www.2055vrc.live or find us on our instagram @2055vrc. 
          </div>
        </section>
      </main>

      <footer>
        <p>&copy; {new Date().getFullYear()} Mi3L Schools. All rights reserved. Made by Edison Ying</p>
      </footer>
    </div>
  );
};

export default Home;
